import api from "./api.ts";

class authRequests {
    async getUserInfo() {
        return await api.get('/Authenticate/me')
    }

    // Gửi email (validate backend)
    async requestEmail(email: string) {
        return await api.post('/Authenticate/verify-email', {email})
    }

    // Gửi OTP tới số điện thoại
    async requestPhone(phone: string, userId: any) {
        return await api.post('/Authenticate/verify-phone', {phone, userId})
    }

    // Xác thực OTP, backend set HttpOnly cookies JWT
    async verifyOTP(code: number, phone: string) {
        return await api.post('/Authenticate/verify-otp', {code, phone})
    }

    async refreshToken() {
        return await api.post('/Authenticate/refresh')
    }

    async logout() {
        return await api.post('/Authenticate/logout')
    }
}

export default new authRequests();